import { Injectable } from "@angular/core";
import { HttpService } from "../providers/http.service";
import { AppConfig } from "../app/app.config";

@Injectable()
export class KaiXuanService {
    constructor(private httpService: HttpService, private AppConfig: AppConfig) { }

    /**
     *登录凯旋棋牌
     */
    login(kindId: string = '0') {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/Login";
        return this.httpService.post(url, { KindID: kindId });
    }

    /**
     * 转账到凯旋棋牌
     */
    transferToGamKX(money: number) {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/TransferToKaiXuan";
        return this.httpService.post(url, { Money: money, Type: 0 })
    }
    /**
     *凯旋棋牌转账到平台
     */
    transferFromKX(money: number) {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/TransferFromKaiXuan";
        return this.httpService.post(url, { Money: money, Type: 1 })
    }

    /**
     *获取凯旋棋牌余额
     *
     */
    getBalance() {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/GetBalance";
        return this.httpService.post(url, '')
    }

    /**
     *获取凯旋棋牌转账记录
     */
    GetTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**
     *获取凯旋棋牌投注记录
     */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/KaiXuan/GetBettingList";
        return this.httpService.post(url, params);
    }
}


// WEBPACK FOOTER //
// ./src/services/kaixuan.service.ts